"use client";

import { useState } from "react";
import Input from "../components/Input";
import BackHeader from "../components/BackHeader";
import AddressItem from "../components/AddressItem";
// import AddressItem from "./swipe-and-delete/AddressItem";

const CryptoAddressPage = () => {
    const [addresses, setAddresses] = useState([
        {
            id: 1,
            tag: "My Binance BTC Adress",
            address: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa",
        },
        {
            id: 2,
            tag: "My Binance BTC Adress",
            address: "1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa",
        },
    ]);

    const [newTag, setNewTag] = useState("");
    const [newAddress, setNewAddress] = useState("");

    const handleAddAddress = () => {
        if (newTag.trim() && newAddress.trim()) {
            const newId =
                addresses.length > 0
                    ? Math.max(...addresses.map((a) => a.id)) + 1
                    : 1;
            setAddresses([
                ...addresses,
                { id: newId, tag: newTag, address: newAddress },
            ]);
            setNewTag("");
            setNewAddress("");
        }
    };

    const handleDeleteAddress = (id) => {
        setAddresses(addresses.filter((address) => address.id !== id));
    };

    return (
        <div className="min-vh-100">
            <BackHeader title="Crypto Address" />

            {/* Form Section */}
            <div className="container mt-3">
                <div
                    className="p-4"
                    style={{
                        backgroundColor: "#1E1E1E",
                        borderRadius: "12px",
                    }}
                >
                    <Input
                        label="#TAG"
                        id="input"
                        placeholder="Your Tag"
                        value={newTag}
                        onChange={(e) => setNewTag(e.target.value)}
                    />

                    <Input
                        label="CRYPTO ADDRESS"
                        id="input"
                        placeholder="Enter your address"
                        value={newAddress}
                        onChange={(e) => setNewAddress(e.target.value)}
                        className="mb-4"
                    />

                    <div
                        className="w-100 rounded-3 py-3 justify-content-center d-flex font-600"
                        onClick={handleAddAddress}
                        style={{
                            backgroundColor: "#2E2CB2",
                            cursor: "pointer",
                            color: "#fff",
                        }}
                    >
                        Add
                    </div>
                </div>
            </div>

            {/* Address List Section */}
            <div className="container mt-4">
                <div
                    className="p-4"
                    style={{
                        backgroundColor: "#1E1E1E",
                        borderRadius: "12px",
                    }}
                >
                    <h2 className="mb-4" style={{ fontSize: "20px" }}>
                        Your address list
                    </h2>

                    <div className="address-list">
                        {addresses.map((address) => (
                            <AddressItem
                                key={address.id}
                                address={address}
                                onDelete={handleDeleteAddress}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CryptoAddressPage;
